const initState = {
  successFetching: false,
  errorFetching: false,
  indicators: [],
};

export default initState;
